import { NoAvailabilityReason } from "@rooster/types";
import { baseUrlFunctions } from "./common";
import { axiosWithRetry } from "./utils/axiosRetry";

export async function logErrorAndNotifyUserForRoosterLinks({
  errorCode,
  context
}: {
  errorCode: string;
  context: Record<string, string>;
}) {
  const url = `${baseUrlFunctions}/personalMeetingLinks/roosterlinks/error-log-handler`;
  try {
    const response = await axiosWithRetry(url, "post", {
      data: {
        errorCode,
        context
      },
      timeout: 120000
    });
    return response.data;
  } catch (error: unknown) {
    console.log(error instanceof Error ? error?.message : error);
  }
}

export async function logErrorAndNotifyUserForRoosterInitiatedLinks({
  errorCode,
  context,
  noAvailabilityReason,
  isReschedule
}: {
  errorCode: string;
  context: Record<string, string>;
  noAvailabilityReason?: NoAvailabilityReason;
  isReschedule?: boolean;
}) {
  const url = `${baseUrlFunctions}/autobookRequest/autobookInterview/error-log-handler`;
  try {
    const response = await axiosWithRetry(url, "post", {
      data: {
        errorCode,
        context,
        noAvailabilityReason,
        isReschedule
      },
      timeout: 120000
    });
    return response.data;
  } catch (error: unknown) {
    console.error(error instanceof Error ? error?.message : error);
  }
}
